module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isVisible) ? _c('div', {
    staticClass: "rf-status",
    class: _vm.computedClass
  }, [_vm._t("default", [_c('pre', [_vm._v(_vm._s(_vm.message))])], {
    message: _vm.message
  }), _vm._v(" "), _c('ul', _vm._l((_vm.items), function(value, key) {
    return _c('li', {
      key: key
    }, [_c('b', [_vm._v(_vm._s(key) + ":")]), _vm._v(" "), (Array.isArray(value)) ? _c('ul', _vm._l((value), function(message, key) {
      return _c('li', {
        key: key
      }, [_vm._v(_vm._s(message))])
    })) : _c('span', [_vm._v(_vm._s(_vm.item))])])
  }))], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1563b730","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/frontend/components/RfStatus.vue
// module id = 254
// module chunks = 0